import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { RoleResponse } from '@/api/roles/types';

export const DEFAULT_GEO_RADIUS_M = 1000;
export const MIN_GEO_RADIUS_M = 50;
export const MAX_GEO_RADIUS_M = 100000;

export const createOrgModalSchema = (allOrganizations: any, allRoles: RoleResponse[]) =>
  [
    {
      key: 'regionParentId',
      label: 'Областной уровень',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'parentId',
      label: 'Районный уровень',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'name',
      label: 'Полное название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
    {
      key: 'shortName',
      label: 'Краткое название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
    {
      key: 'roleNames',
      label: 'Роли в организации',
      type: 'select',
      payload: {
        options: allRoles,
        mode: 'multiple',
        fieldNames: {
          label: 'description',
          value: 'name',
        },
      },
      validation: [Validators.required()],
    },
  ] as IFormItem[];

export const createStructuralModalSchema = (allOrganizations: any) =>
  [
    {
      key: 'parentId',
      label: 'Организация',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'name',
      label: 'Название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
    {
      key: 'latitude',
      label: 'Широта',
      type: 'text',
      placeholder: 'Введите широту',
      validation: [
        Validators.required(),
        Validators.coordinates('Введите корректную широту'),
      ],
    },
    {
      key: 'longitude',
      label: 'Долгота',
      type: 'text',
      placeholder: 'Введите долготу',
      validation: [
        Validators.required(),
        Validators.coordinates('Введите корректную долготу'),
      ],
    },
    {
      key: 'geoRadiusM',
      label: 'Радиус проверки геолокации (м)',
      type: 'number',
      placeholder: 'Введите радиус',
      default: DEFAULT_GEO_RADIUS_M,
      payload: { max: MAX_GEO_RADIUS_M },
      validation: [
        Validators.required(),
        {
          type: 'number',
          min: MIN_GEO_RADIUS_M,
          max: MAX_GEO_RADIUS_M,
          message: `Радиус должен быть от ${MIN_GEO_RADIUS_M} до ${MAX_GEO_RADIUS_M} м`,
        },
      ],
    },
  ] as IFormItem[];

export const createFacilityModalSchema = (allOrganizations: any, objectDictionary: any) =>
  [
    {
      key: 'orgId',
      label: 'Организация',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'parentId',
      label: 'Структурное подразделение',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'individualLocationId',
      label: 'Объект',
      type: 'select',
      placeholder: 'Выберите объект',
      payload: {
        options: objectDictionary,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
      validation: [Validators.required()],
    },
    {
      key: 'name',
      label: 'Название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
  ] as IFormItem[];
